export default {
  page: "Kids"
};
